module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ambis-meter-edit-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Meter',
          to: {
            path: '/ambis-meter'
          },
        },
        {
          text: 'Ubah Ambis Meter'
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s("Ubah Ambis Meter") + "\n    ")]), _vm._v(" "), _c('v-card', [_c('v-tabs', [_c('v-tab', [_vm._v("Periode")]), _vm._v(" "), _c('v-tab', [_vm._v("Kelas dan Misi")]), _vm._v(" "), _c('v-tab', [_vm._v("Level")]), _vm._v(" "), _c('v-tab-item', [_c('div', {
    staticClass: "mx-5 my-5"
  }, [_c('app-periode-editform')], 1)]), _vm._v(" "), _c('v-tab-item', [_c('div', {
    staticClass: "mx-5 my-5"
  }, [_c('app-mission-editform')], 1)]), _vm._v(" "), _c('v-tab-item', [_c('div', {
    staticClass: "mx-5 my-5"
  }, [_c('app-level-editform')], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f4f1eee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/AmbisMeterEditForm.vue
// module id = 972
// module chunks = 1